/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TaskActionResultSummary } from './taskActionResultSummary';
import { MessageStateEnum } from './messageStateEnum';
import { NotificationResultSummary } from './notificationResultSummary';
import { RolloutActionType } from './rolloutActionType';


/**
 * @type ActionResultSummary
 * @export
 */
export type ActionResultSummary = NotificationResultSummary | TaskActionResultSummary;

